<!-- Footer Start -->
<div class="container-fluid bg-dark text-light">
  <div class="container">
    <div class="row gx-5">

      <!-- About -->
      <div class="col-lg-4 col-md-6 footer-about">
        <div class="d-flex flex-column align-items-center justify-content-center text-center h-100 bg-primary p-4">
          <a routerLink="/" class="navbar-brand">
            <h1 class="m-0 text-white">Delex</h1>
          </a>

          <p class="mt-3 mb-4">
            At Delex, we deliver high-performance web solutions that help you grow your business online. From design to deployment, we’re your trusted digital partner.
          </p>

          <form>
            <div class="input-group">
              <input type="text" class="form-control border-white mrb-0" placeholder="Enter your email">
              <button class="btn btn-dark">Subscribe</button>
            </div>
          </form>
        </div>
      </div>

      <!-- Right Footer -->
      <div class="col-lg-8 col-md-6">
        <div class="row gx-5">

          <!-- Contact -->
          <div class="col-lg-4 col-md-12 pt-5 mb-5">

            <div class="section-title section-title-sm position-relative pb-3 mb-4">
              <h3 class="text-light mb-0">Contact Us</h3>
            </div>

            <div *ngFor="let contact of contactInfo" class="d-flex mb-2">
              <i class="bi text-primary me-2" [ngClass]="contact.icon"></i>
              <p class="mb-0">{{contact.text}}</p>
            </div>

            <!-- Social -->
            <div class="d-flex mt-4">
              <a *ngFor="let social of socialLinks"
                 class="btn btn-primary border-radius me-2"
                 [href]="social.link">
                 <i [class]="social.icon + ' fw-normal'"></i>
              </a>
            </div>

          </div>

          <!-- Quick Links -->
          <div class="col-lg-4 col-md-12 pt-0 pt-lg-5 mb-5">

            <div class="section-title section-title-sm position-relative pb-3 mb-4">
              <h3 class="text-light mb-0">Quick Links</h3>
            </div>

            <div class="link-animated d-flex flex-column justify-content-start">
              <a *ngFor="let link of quickLinks"
                 class="text-light mb-2"
                 [routerLink]="link.link">
                 <i class="bi bi-arrow-right text-primary me-2"></i>
                 {{link.name}}
              </a>
            </div>

          </div>

          <!-- Resources -->
          <div class="col-lg-4 col-md-12 pt-0 pt-lg-5 mb-5">

            <div class="section-title section-title-sm position-relative pb-3 mb-4">
              <h3 class="text-light mb-0">Resources</h3>
            </div>

            <div class="link-animated d-flex flex-column justify-content-start">
              <a *ngFor="let item of resources"
                 class="text-light mb-2"
                 [href]="item.link">
                 <i class="bi bi-arrow-right text-primary me-2"></i>
                 {{item.name}}
              </a>
            </div>

          </div>

        </div>
      </div>

    </div>
  </div>
</div>

<!-- Copyright -->
<div class="container-fluid text-white" style="background:#061429;">
  <div class="container text-center">
    <div class="row justify-content-end">
      <div class="col-lg-8 col-md-6">
        <div class="d-flex align-items-center justify-content-center" style="height:75px;">
          <p class="mb-0">
            &copy; {{currentYear}} Delex. All Rights Reserved. Designed by <a href="https://themeforest.net/user/designsninja" target="_blank">DesignsNinja</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Footer End -->